export default __webpack_public_path__ + "static/media/bg_login.7da99e88.jpg";